import { useState, useRef, useEffect } from 'react';
import InfoIcon from './ic-view-info-normal.svg';
import InfoHoverIcon from './ic-view-info-hover.svg';
import InfoActiveIcon from './ic-view-info-pressed.svg';

export const DescriptionButton = ({ record }: { record: any }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setIsPopoverOpen(false);
      }
    };

    if (isPopoverOpen) document.addEventListener('mousedown', handleOutsideClick);
    else document.removeEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isPopoverOpen]);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return (
    <div className='inline-block max-[840px]:hidden'>
      <button
        ref={buttonRef}
        className='focus:outline-none'
        onClick={(e) => {
          e.stopPropagation();
          setIsPopoverOpen(!isPopoverOpen);
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className=' cursor-pointer'>{isPopoverOpen ? <InfoActiveIcon /> : isHovered ? <InfoHoverIcon /> : <InfoIcon />}</div>
      </button>

      {isPopoverOpen && (
        <div
          ref={popoverRef}
          className='absolute !z-[9999] bg-white border border-gray-300 shadow-lg p-2 rounded min-w-[200px] -top-15 right-51 text-base px-5 py-4'
          onClick={(e) => e.stopPropagation()}
        >
          <div className='absolute -bottom-[16px] -left-1 w-full flex justify-end'>
            <div className='relative h-5 w-10'>
              <div
                className='absolute top-0 left-1/2 transform -translate-x-1/2 w-0 h-0 
                  border-l-[12px] border-l-transparent
                  border-r-[12px] border-r-transparent'
              ></div>
              <div
                className='absolute top-[1px] left-1/2 transform -translate-x-1/2 w-0 h-0 
                  border-l-[11px] border-l-transparent
                  border-t-[11px] border-t-white
                  border-r-[11px] border-r-transparent'
              ></div>
            </div>
          </div>

          {record.feesDescription?.map((item: any, index: number) => <div key={index}>{item}</div>)}
        </div>
      )}
    </div>
  );
};
